const SHORT_DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] as const;

/** Reject impossible ISO dates like 2026-02-31 via UTC calendar round-trip. */
export function isValidCalendarDateIso(iso: string): boolean {
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return false;
  const yr = Number(m[1]);
  const mo = Number(m[2]);
  const dy = Number(m[3]);
  const probe = new Date(Date.UTC(yr, mo - 1, dy));
  return (
    probe.getUTCFullYear() === yr &&
    probe.getUTCMonth() + 1 === mo &&
    probe.getUTCDate() === dy
  );
}

/**
 * Given an ISO start date (YYYY-MM-DD) and a 0-based day index, return the
 * day-of-week abbreviation and the calendar date in DD/MM/YYYY format.
 * Uses UTC arithmetic to avoid daylight-saving boundary shifts.
 */
export function calendarInfoForCycleDay(
  startDateIso: string,
  dayIndex: number
): { dow: string; date: string } {
  const m = startDateIso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return { dow: "", date: "" };
  const d = new Date(
    Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]) + dayIndex)
  );
  const dow = SHORT_DAY_NAMES[d.getUTCDay()];
  const dd = String(d.getUTCDate()).padStart(2, "0");
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  const yyyy = d.getUTCFullYear();
  return { dow, date: `${dd}/${mm}/${yyyy}` };
}

/** Label for a cycle day input, e.g. "Day 3 · Wed · 03/07/2026". */
export function cycleDayInputLabel(
  startDateIso: string,
  dayIndex: number
): string {
  const { dow, date } = calendarInfoForCycleDay(startDateIso, dayIndex);
  const dayNumber = dayIndex + 1;
  if (!dow || !date) {
    return `Day ${dayNumber}`;
  }
  return `Day ${dayNumber} · ${dow} · ${date}`;
}
